import { TribunalJobType, } from '@debbie/common/dist/tribunal/jobs/types.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useUpdatesByRefId } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import HTMLEmail from '../../Email/HTMLEmail.js';
import { ArrowRight } from '../../Icons/index.js';
import { File, Money, Table } from '../../index.js';
import CourtMeetingJob from './Jobs/CourtMeeting.js';
import DistraintJob from './Jobs/Distraint.js';
export const TribunalJob = (props) => {
    const lang = useSelector((s) => s.lang);
    const { type, data, result } = props.job;
    return (React.createElement(StyledJob, null,
        React.createElement("div", null,
            type === TribunalJobType.RegisterInsolvency && (React.createElement(Insolvency, { updateId: result.updateId, caseId: props.tribunalCase.caseId })),
            type === TribunalJobType.RegisterInsolvens && (React.createElement(Insolvency, { updateId: result.updateId, caseId: props.tribunalCase.caseId })),
            (type === TribunalJobType.CreateBetalingspaakrav ||
                type === TribunalJobType.ResendBetalingspaakrav ||
                type === TribunalJobType.GLCreateBetalingspaakrav ||
                type === TribunalJobType.GLResendBetalingspaakrav) &&
                result.betalingspaakravFileId && (React.createElement("div", null,
                React.createElement(File, { file: {
                        contentType: 'application/pdf',
                        fileId: result.betalingspaakravFileId,
                        fileName: 'Betalingspåkrav.pdf',
                    } }))),
            type === TribunalJobType.Register1Paategning && (React.createElement("div", null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: '30%' } }, lang.tribunal.date),
                        React.createElement("td", null,
                            React.createElement("b", null, moment(data.date).format(THEME.DATE_FORMAT_SHORT)))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: '30%' } }, lang.tribunal.courtCaseCosts),
                        React.createElement("td", null,
                            React.createElement("b", null,
                                React.createElement(Money, { amount: data.costs })))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: '30%' } }, lang.tribunal.document),
                        React.createElement("td", null, data.fileId ? (React.createElement(File, { file: {
                                contentType: 'application/pdf',
                                fileId: data.fileId,
                                fileName: '1-påtegning.pdf',
                            } })) : (React.createElement("b", null, lang.tribunal.notRegistered))))))),
            type === TribunalJobType.Register2Paategning && (React.createElement("div", null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: '30%' } }, lang.tribunal.date),
                        React.createElement("td", null,
                            React.createElement("b", null, data.date
                                ? moment(data.date).format(THEME.DATE_FORMAT_SHORT)
                                : ''))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: '30%' } }, lang.tribunal.document),
                        React.createElement("td", null, data.fileId ? (React.createElement(File, { file: {
                                contentType: 'application/pdf',
                                fileId: data.fileId,
                                fileName: '2-påtegning.pdf',
                            } })) : (React.createElement("b", null, lang.tribunal.notRegistered))))))),
            type === TribunalJobType.CourtMeeting && (React.createElement(CourtMeetingJob, { job: props.job, tribunalCase: props.tribunalCase })),
            type === TribunalJobType.Distraint && (React.createElement(DistraintJob, { job: props.job, tribunalCase: props.tribunalCase })),
            type === TribunalJobType.RegisterPolicePresentation && data.date && (React.createElement("div", null,
                React.createElement(Table, { zebra: true },
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: '30%' } }, lang.tribunal.debtorSentToPolicePresentation),
                        React.createElement("td", null,
                            React.createElement("b", null, moment(data.date).format(THEME.DATE_FORMAT_SHORT))))))),
            type === TribunalJobType.Note && (React.createElement(HTMLEmail, { html: `
          <style>
            * {
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
             }
          </style>
          ${data.note}
          ` })),
            type === TribunalJobType.CloseCase && data.note && (React.createElement(HTMLEmail, { html: `
          <style>
            * {
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
             }
          </style>
          ${data.note}
          ` })))));
};
export default TribunalJob;
const StyledJob = styled.div `
  background-color: #e6e6e6;
  border-radius: 2px;
  padding: ${THEME.GRID_SPACING / 2}px ${THEME.GRID_SPACING}px;
`;
const Insolvency = (props) => {
    const updatesLoadable = useUpdatesByRefId(props.caseId);
    const caseUpdates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const update = caseUpdates?.find((u) => u.updateId === props.updateId);
    if (!update) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement("p", null,
            moment(update.pausedAt).format(THEME.DATE_FORMAT_SHORT),
            ' ',
            React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em' } }),
            ' ',
            moment(update.remindedAt).format(THEME.DATE_FORMAT_SHORT))));
};
//# sourceMappingURL=TribunalJob.js.map